import React from 'react';
import {
  Box,
  Card,
  Button,
  MenuItem,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
  Tooltip
} from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { format } from 'date-fns';
import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';

let d = new Date();
const getISODay = d => (d.getDay() + 6) % 7 + 1;

let today = format(d, 'yyyy-MM-dd');
let yesterday = format(new Date(new Date(d).setDate(d.getDate() - 1)), 'yyyy-MM-dd');
let d1Month = format(new Date(d.getFullYear(), d.getMonth(), 1), 'yyyy-MM-dd');
let d1Year = format(new Date(d.getFullYear(), 0, 1), 'yyyy-MM-dd');
let d1Week = format(new Date(new Date(d).setDate(d.getDate() - getISODay(d) + 1)), 'yyyy-MM-dd');

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getDeliveryPercentage(location) {
  const value = Number(location.value) || 0;

  if (value === 0) {
    return 0;
  }

  const deliveryValue =
    (Number(location.valueGlovo) || 0) +
    (Number(location.valueBolt) || 0) +
    (Number(location.valueWolt) || 0);

  return (deliveryValue / value) * 100;
}

const period = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
  { value: 'year', label: 'This Year' },
  { value: 'custom', label: 'Custom' }
];

const objectToCsv = function (data) {
  const csvRows = [];
  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header];
      return `"${val}"`;
    });
    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

class SalesYTDLocationListDelivery extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      saleslocation_list: [],
      page: 0,
      rowsPerPage: -1,
      order: 'asc',
      orderBy: null,
      dateFrom: d1Month,
      dateTo: today,
      sx_hidden: { display: 'none' },
      value: "1",
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.addDateFrom = this.addDateFrom.bind(this);
    this.addDateTo = this.addDateTo.bind(this);
    this.selectPeriod = this.selectPeriod.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let queryData = {
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo
    };

    let data = BackofficeReportsApi.getSalesByDeliveryChannel(this.state.client, queryData);

    if (data) {
      this.setState({ saleslocation_list: data });
    }

    this.setState({ filterData: queryData });
  }

  doSync() {
    this.getData();
    this.setState({ page: 0 });
  }

  addDateFrom = (event) => {
    this.setState({ dateFrom: event.target.value });
  }

  addDateTo = (event) => {
    this.setState({ dateTo: event.target.value });
  }

  selectPeriod = (event) => {
    switch (event.target.value) {
      case "today":
        this.setState({ sx_hidden: { display: 'none' } },
          this.setState(
            { dateFrom: today },
            function () {}
          ));
        this.setState(
          { dateTo: today },
          function () {
            this.doSync();
          }
        );
        break;

      case "yesterday":
        this.setState({ sx_hidden: { display: 'none' } },
          this.setState(
            { dateFrom: yesterday },
            function () {}
          ));
        this.setState(
          { dateTo: yesterday },
          function () {
            this.doSync();
          }
        );
        break;

      case "week":
        this.setState({ sx_hidden: { display: 'none' } },
          this.setState(
            { dateFrom: d1Week },
            function () {}
          ));
        this.setState(
          { dateTo: today },
          function () {
            this.doSync();
          }
        );
        break;

      case "month":
        this.setState({ sx_hidden: { display: 'none' } },
          this.setState(
            { dateFrom: d1Month },
            function () {}
          ));
        this.setState(
          { dateTo: today },
          function () {
            this.doSync();
          }
        );
        break;

      case "year":
        this.setState({ sx_hidden: { display: 'none' } },
          this.setState(
            { dateFrom: d1Year },
            function () {}
          ));
        this.setState(
          { dateTo: today },
          function () {
            this.doSync();
          }
        );
        break;

      default:
        this.setState(
          { sx_hidden: {} },
          function () {
            this.doSync();
          }
        );
    }
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  }

  handleRequestSort = (property) => {
    const isAscending = this.state.orderBy === property && this.state.order === 'asc';

    this.setState({
      order: isAscending ? 'desc' : 'asc',
      orderBy: property,
      page: 0
    });
  }

  onDownload = () => {
    const link = document.createElement("a");
    link.download = "salesDelivery_" + this.state.dateFrom + "-" + this.state.dateTo + ".csv";

    let csvData = objectToCsv(this.state.saleslocation_list.result);
    let csvHeader = "Sales value Delivery\nDate From: " + this.state.dateFrom + "\nDate To: " + this.state.dateTo;
    let csv = "\uFEFF" + csvHeader + "\n" + csvData;

    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    link.click();
  };

  render() {
    let page = this.state.page;
    let rowsPerPage = this.state.rowsPerPage;
    let locationSalesData = [];
    let locationSalesList = [];

    if (this.state.saleslocation_list) {
      if (this.state.saleslocation_list.result) {
        let counter = 0;

        Object.keys(this.state.saleslocation_list.result).forEach(key => {
          let fData = this.state.saleslocation_list.result[key];

          let myData = {
            x: fData.name,
            y: (parseInt(fData.value / 1000) + "K")
          };

          let p = {
            id: counter + 1,
            name: fData.name,
            value: fData.value,
            valueGlovo: fData.value_Glovo,
            valueBolt: fData.value_Bolt,
            valueWolt: fData.value_Tazz
          };

          if (counter < 10) {
            locationSalesData.push(myData);
          }

          counter += 1;
          locationSalesList.push(p);
        });
      }
    }

    const { order, orderBy } = this.state;
    const sortedLocationSalesList = orderBy
      ? [...locationSalesList].sort((a, b) => {
          let aValue;
          let bValue;

          if (orderBy === 'name') {
            aValue = (a.name || '').toLocaleLowerCase();
            bValue = (b.name || '').toLocaleLowerCase();
          } else if (orderBy === 'deliveryPercentage') {
            aValue = getDeliveryPercentage(a);
            bValue = getDeliveryPercentage(b);
          } else {
            aValue = Number(a[orderBy]) || 0;
            bValue = Number(b[orderBy]) || 0;
          }

          if (aValue < bValue) return order === 'asc' ? -1 : 1;
          if (aValue > bValue) return order === 'asc' ? 1 : -1;
          return 0;
        })
      : locationSalesList;

    const tableContainerSx = {
      flex: 1,
      minHeight: 0,
      overflow: 'auto',
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      '&::-webkit-scrollbar': {
        height: 8,
        width: 8,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(15, 23, 42, 0.18)',
        borderRadius: 999,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(15, 23, 42, 0.04)',
      },
    };

    const tableSx = {
      minWidth: {
        xs: 640,
        sm: 760,
        md: '100%',
      },
      width: '100%',
      tableLayout: {
        xs: 'fixed',
        md: 'auto'
      },
      '& .MuiTableCell-root': {
        borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
        fontSize: {
          xs: '0.78rem',
          sm: '0.88rem',
          md: '0.92rem',
        },
      },
      '& .MuiTableRow-hover:hover': {
        backgroundColor: 'rgba(26, 35, 126, 0.035)',
      },
    };

    const headerCellSx = {
      py: {
        xs: 0.55,
        sm: 0.85,
      },
      px: {
        xs: 0.5,
        sm: 1,
      },
      bgcolor: '#f8fafc',
      color: '#1a237e',
      fontWeight: 650,
      lineHeight: 1.15,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    };

    const bodyCellSx = {
      py: {
        xs: 0.6,
        sm: 0.8,
      },
      px: {
        xs: 0.5,
        sm: 1,
      },
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontVariantNumeric: 'tabular-nums',
    };

    const nameCellSx = {
      ...bodyCellSx,
      position: 'sticky',
      left: 0,
      zIndex: 2,
      bgcolor: '#fff',
      fontWeight: 550,
      fontVariantNumeric: 'normal',
    };

    const nameHeaderCellSx = {
      ...headerCellSx,
      position: 'sticky',
      left: 0,
      zIndex: 4,
    };

    const paginationSx = {
      flexShrink: 0,
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      bgcolor: '#fff',
      minHeight: {
        xs: 44,
        sm: 52,
      },
      '& .MuiTablePagination-toolbar': {
        minHeight: {
          xs: 44,
          sm: 52,
        },
        px: {
          xs: 0.5,
          sm: 1,
        },
        flexWrap: {
          xs: 'wrap',
          sm: 'nowrap',
        },
        gap: {
          xs: 0.25,
          sm: 0.5,
        },
      },
      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        fontSize: {
          xs: '0.88rem',
          sm: '0.92rem',
          md: '1rem',
        },
        m: 0,
      },
      '& .MuiTablePagination-actions': {
        ml: {
          xs: 0,
          sm: 1,
        },
      },
    };

    return (
      <Paper
        sx={{
          position: 'relative',
          width: '100%',
          height: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          maxHeight: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          minHeight: 0,
          borderRadius: {
            xs: '14px',
            sm: '16px',
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          bgcolor: '#fff',
        }}
      >
        <Card
          sx={{
            height: '100%',
            minHeight: 0,
            borderRadius: 0,
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              px: {
                xs: 0.75,
                sm: 1,
              },
              py: {
                xs: 0.65,
                sm: 0.85,
              },
              flexShrink: 0,
              borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
              bgcolor: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: {
                  xs: 'stretch',
                  sm: 'center',
                },
                justifyContent: 'space-between',
                gap: {
                  xs: 0.75,
                  sm: 1,
                },
                flexDirection: {
                  xs: 'column',
                  sm: 'row',
                },
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  sx={{
                    color: '#1a237e',
                    fontWeight: 800,
                    fontSize: {
                      xs: '0.9rem',
                      sm: '1rem',
                    },
                    lineHeight: 1.2,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  Delivery Sales
                </Typography>

                <Typography
                  sx={{
                    mt: 0.15,
                    color: '#64748b',
                    fontWeight: 600,
                    fontSize: {
                      xs: '0.72rem',
                      sm: '0.78rem',
                    },
                    lineHeight: 1.2,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  Sales value by location and delivery platform
                </Typography>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: {
                    xs: 'space-between',
                    sm: 'flex-end',
                  },
                  gap: 0.75,
                  flexWrap: 'wrap',
                }}
              >
                <TextField
                  id="standard-select-period"
                  select
                  defaultValue="month"
                  size="small"
                  sx={{
                    width: {
                      xs: 132,
                      sm: 130,
                    },
                    '& .MuiInputBase-root': {
                      height: 36,
                      borderRadius: '12px',
                      fontSize: {
                        xs: '0.82rem',
                        sm: '0.88rem',
                      },
                      bgcolor: '#fff',
                    },
                  }}
                  onChange={this.selectPeriod}
                >
                  {period.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <Tooltip title="Download CSV">
                  <Button
                    size="small"
                    onClick={this.onDownload}
                    variant="contained"
                    sx={{
                      minWidth: 36,
                      width: 36,
                      height: 36,
                      p: 0,
                      flexShrink: 0,
                      borderRadius: '12px',
                      color: '#1a237e',
                      bgcolor: 'rgba(26, 35, 126, 0.08)',
                      boxShadow: 'none',
                      border: '1px solid rgba(26, 35, 126, 0.12)',
                      '&:hover': {
                        bgcolor: 'rgba(26, 35, 126, 0.12)',
                        boxShadow: 'none',
                      },
                    }}
                  >
                    <FileDownloadIcon fontSize="small" />
                  </Button>
                </Tooltip>
              </Box>
            </Box>

            <Box
              sx={{
                ...this.state.sx_hidden,
                mt: 0.85,
                alignItems: 'center',
                gap: 0.75,
                flexWrap: 'wrap',
              }}
            >
              <TextField
                size="small"
                id="date-from"
                label="From"
                type="date"
                value={this.state.dateFrom}
                sx={{
                  width: {
                    xs: 'calc(50% - 24px)',
                    sm: 130,
                  },
                  '& .MuiInputBase-root': {
                    height: 36,
                    borderRadius: '12px',
                    fontSize: {
                      xs: '0.8rem',
                      sm: '0.86rem',
                    },
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: {
                      xs: '0.76rem',
                      sm: '0.82rem',
                    },
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  style: {
                    paddingRight: 5,
                    paddingLeft: 5
                  }
                }}
                onChange={this.addDateFrom}
              />

              <TextField
                size="small"
                id="date-to"
                label="To"
                type="date"
                value={this.state.dateTo}
                sx={{
                  width: {
                    xs: 'calc(50% - 24px)',
                    sm: 130,
                  },
                  '& .MuiInputBase-root': {
                    height: 36,
                    borderRadius: '12px',
                    fontSize: {
                      xs: '0.8rem',
                      sm: '0.86rem',
                    },
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: {
                      xs: '0.76rem',
                      sm: '0.82rem',
                    },
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  style: {
                    paddingRight: 5,
                    paddingLeft: 5
                  }
                }}
                onChange={this.addDateTo}
              />

              <Tooltip title="Refresh">
                <Button
                  onClick={() => this.doSync()}
                  variant="contained"
                  sx={{
                    minWidth: 36,
                    width: 36,
                    height: 36,
                    p: 0,
                    flexShrink: 0,
                    borderRadius: '12px',
                    boxShadow: 'none',
                    '&:hover': {
                      boxShadow: 'none',
                    },
                  }}
                >
                  <AutorenewIcon fontSize="small" />
                </Button>
              </Tooltip>
            </Box>
          </Box>

          <TableContainer sx={tableContainerSx}>
            <Table stickyHeader aria-label="delivery sales table" sx={tableSx}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      ...nameHeaderCellSx,
                      width: {
                        xs: 130,
                        sm: 180,
                        md: '28%',
                      },
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === 'name'}
                      direction={orderBy === 'name' ? order : 'asc'}
                      onClick={() => this.handleRequestSort('name')}
                    >
                      Name
                    </TableSortLabel>
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: 92,
                        sm: 110,
                        md: '15%',
                      },
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === 'value'}
                      direction={orderBy === 'value' ? order : 'asc'}
                      onClick={() => this.handleRequestSort('value')}
                    >
                      Value
                    </TableSortLabel>
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: 82,
                        sm: 100,
                        md: '12%',
                      },
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === 'deliveryPercentage'}
                      direction={orderBy === 'deliveryPercentage' ? order : 'asc'}
                      onClick={() => this.handleRequestSort('deliveryPercentage')}
                    >
                      % Del.
                    </TableSortLabel>
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: 98,
                        sm: 115,
                        md: '15%',
                      },
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === 'valueGlovo'}
                      direction={orderBy === 'valueGlovo' ? order : 'asc'}
                      onClick={() => this.handleRequestSort('valueGlovo')}
                    >
                      Glovo
                    </TableSortLabel>
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: 92,
                        sm: 110,
                        md: '15%',
                      },
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === 'valueBolt'}
                      direction={orderBy === 'valueBolt' ? order : 'asc'}
                      onClick={() => this.handleRequestSort('valueBolt')}
                    >
                      Bolt
                    </TableSortLabel>
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: 92,
                        sm: 110,
                        md: '15%',
                      },
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === 'valueWolt'}
                      direction={orderBy === 'valueWolt' ? order : 'asc'}
                      onClick={() => this.handleRequestSort('valueWolt')}
                    >
                      Wolt
                    </TableSortLabel>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? sortedLocationSalesList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : sortedLocationSalesList
                ).map((location) => {
                  return (
                    <TableRow hover key={location.id} tabIndex={-1}>
                      <TableCell
                        sx={{
                          ...nameCellSx,
                          width: {
                            xs: 130,
                            sm: 180,
                            md: '28%',
                          },
                        }}
                      >
                        {location.name}
                      </TableCell>

                      <TableCell align="right" sx={bodyCellSx}>
                        {thousandsSeparator(parseInt(location.value))}
                      </TableCell>

                      <TableCell align="right" sx={bodyCellSx}>
                        {location.value === 0
                          ? 0 + "%"
                          : Number(((location.valueGlovo + location.valueBolt + location.valueWolt) / location.value) * 100).toFixed(1) + "%"}
                      </TableCell>

                      <TableCell align="right" sx={bodyCellSx}>
                        {thousandsSeparator(parseInt(location.valueGlovo))}
                      </TableCell>

                      <TableCell align="right" sx={bodyCellSx}>
                        {thousandsSeparator(parseInt(location.valueBolt))}
                      </TableCell>

                      <TableCell align="right" sx={bodyCellSx}>
                        {thousandsSeparator(parseInt(location.valueWolt))}
                      </TableCell>
                    </TableRow>
                  );
                })}

                {locationSalesList.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Box
                        sx={{
                          py: 4,
                          color: 'text.secondary',
                          fontSize: {
                            xs: '0.86rem',
                            sm: '0.92rem',
                          },
                        }}
                      >
                        No data
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, { value: -1, label: 'All' }]}
            labelRowsPerPage="Rows:"
            component="div"
            count={locationSalesList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            sx={paginationSx}
          />
        </Card>
      </Paper>
    );
  }
}

export default SalesYTDLocationListDelivery;
